import { CircuitDayFormData } from '@/types/circuits/CircuitDaysFormData';
import { v4 as uuid } from 'uuid';

type CircuitDayFactory = () => CircuitDayFormData;

export const createCircuitDay: CircuitDayFactory = () => ({
  images: [],
  stepTitle: undefined,
  description: undefined,
  steps: [
    {
      accommodations: {
        standardBenefit: undefined,
        standardBenefitPensionType: undefined,
        optionalBenefits: [],
        optionalBenefitsPensionTypes: {},
        standardDisplays: [],
        optionalDisplays: [],
        time: undefined,
        id: uuid(),
      },
      activities: {
        standardBenefit: undefined,
        standardBenefitPensionType: undefined,
        optionalBenefits: [],
        optionalBenefitsPensionTypes: {},
        standardDisplays: [],
        optionalDisplays: [],
        time: undefined,
        id: uuid(),
      },
      meals: {
        standardBenefit: undefined,
        standardBenefitPensionType: undefined,
        optionalBenefits: [],
        optionalBenefitsPensionTypes: {},
        standardDisplays: [],
        optionalDisplays: [],
        time: undefined,
        id: uuid(),
      },
      transport: {
        standardBenefit: undefined,
        standardBenefitPensionType: undefined,
        optionalBenefits: [],
        optionalBenefitsPensionTypes: {},
        standardDisplays: [],
        optionalDisplays: [],
        time: undefined,
        id: uuid(),
      },
    },
  ],
});

type CircuitDaysFactory = (numberOfDays: number) => CircuitDayFormData[];

export const createEmptyCircuitDays: CircuitDaysFactory = (
  numberOfDays: number,
) => Array.from({ length: numberOfDays }, () => createCircuitDay());
